<script lang="ts">
	import Calendar from '@lucide/svelte/icons/calendar'

	import { Button, type ButtonSize } from '#lib/components/ui/button/index.js'
	import * as DropdownMenu from '#lib/components/ui/dropdown-menu/index.js'
	import { n } from '#lib/utils/navigation.svelte.js'
	import { phg } from '#lib/utils/posthog.js'

	let {
		class: className,
		options,
		value = $bindable(),
		size,
		description,
	}: {
		class?: string
		options: { label: string; value: string }[]
		value: string
		size?: ButtonSize
		description?: string
	} = $props()
</script>

<DropdownMenu.Root>
	<DropdownMenu.Trigger>
		{#snippet child({ props })}
			<Button class={className} disabled={n.l} {size} variant="outline" {...props}>
				<Calendar />

				{options.find(o => o.value === value)?.label ?? 'Metrics Range'}
			</Button>
		{/snippet}
	</DropdownMenu.Trigger>

	<DropdownMenu.Content class="w-52" align="center" preventScroll={false}>
		{#if description}
			<DropdownMenu.Label class="text-2xs text-muted-foreground block">
				{description}
			</DropdownMenu.Label>

			<DropdownMenu.Separator />
		{/if}

		<DropdownMenu.RadioGroup
			onValueChange={value => phg.capture('metrics_range_click', { value })}
			bind:value
		>
			{#each options as { value, label } (value)}
				<DropdownMenu.RadioItem {value}>
					{label}
				</DropdownMenu.RadioItem>
			{/each}
		</DropdownMenu.RadioGroup>
	</DropdownMenu.Content>
</DropdownMenu.Root>
